import { AfterViewInit, Component, computed, ViewChild } from '@angular/core';
import { UserService } from '../../services/user.service';
import { IonButton, IonContent, IonPopover } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { OnboardingService } from '../../services/onboarding.service';

@Component({
  standalone: true,
  selector: 'app-user-avatar',
  imports: [IonButton, IonPopover, IonContent, TranslateModule],
  templateUrl: './user-avatar.component.html',
  styleUrl: './user-avatar.component.scss',
})
export class UserAvatarComponent implements AfterViewInit {
  @ViewChild(IonPopover) popover?: IonPopover;

  public readonly user = this.userService.user;
  public loading: boolean = false;
  public isOpen: boolean = false;

  readonly initials = computed(() => {
    const user = this.user();
    if (!user?.email) return '';

    return this.getInitialsFromEmail(user.email);
  });

  constructor(
    private userService: UserService,
    private onboardingService: OnboardingService
  ) {}

  ngAfterViewInit() {
    this.popover?.ionPopoverDidPresent.subscribe(() => (this.isOpen = true));
    this.popover?.ionPopoverDidDismiss.subscribe(() => (this.isOpen = false));
  }

  private getInitialsFromEmail(email: string): string {
    const localPart = email.split('@')[0]; // before @

    if (localPart.includes('.')) {
      return localPart
        .split('.')
        .slice(0, 2)
        .map((p) => p[0])
        .join('')
        .toUpperCase();
    }

    return localPart.slice(0, 2).toUpperCase();
  }

  async logout() {
    this.loading = true;
    this.popover?.dismiss();

    try {
      await this.userService.logout();
      this.onboardingService.showOnboarding();
    } catch {
      // ignore
    } finally {
      this.loading = false;
    }
  }
}
